module.exports = angular.module('cartographer.common.array', [])

module.exports.factory 'crtArray', $DI (crtLog) ->
  # arrayOf(item) integer -> arrayOf(arrayOf(item))
  groupsOf = (array, number) ->
    ans = []
    for item, index in array
      if index % number == 0 then ans.push([])
      ans[ans.length - 1].push(item)
    # crtLog.debug('crtArray.groupsOf', array, number, ans)
    ans

  return {
    groupsOf
  }
